/**
 * Script for Front Page
 *
 * @author Space-Time Inc.
 * @version 2022-11-28
 */

document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
	/**
	 * Top Visual
	 *
	 * @author Space-Time Inc.
	 * @version 2022-11-29
	 */
	
	function setElementSizeAndAlignment() {
		const es = document.getElementsByClassName('part-top-visual');
		if (!es.length) return;
		const ptv = es[0];
	
		const { paddingTop, paddingLeft, paddingBottom, paddingRight } = getComputedStyle(ptv);
	
		const w = ptv.clientWidth  - parseInt(paddingLeft, 10) - parseInt(paddingRight, 10);
		const h = ptv.clientHeight - parseInt(paddingTop, 10)  - parseInt(paddingBottom, 10);
	
		const s1 = Math.min(w / 3, h);
		const s2 = Math.min(w / 2, h / 2);
		const s3 = Math.min(h / 3, w);
	
		const size = Math.max(s1, s2, s3);
		ptv.style.setProperty('--element-size', `${size}px`);
	
		ptv.classList.remove('row', 'triangle', 'column');
		if (size === s1) {
			ptv.classList.add('row');
		} else if (size === s2) {
			ptv.classList.add('triangle');
		} else if (size === s3) {
			ptv.classList.add('column');
		}
	
		setTimeout(() => {
			ptv.classList.add('visible');
		}, 100);
	}
	

	const shs = document.querySelectorAll('.section-header');

	if (shs.length) {
		function fn() {
			for (const sh of shs) {
				const h = sh.getBoundingClientRect().height;
				sh.parentElement.style.setProperty('--section-height', `${h}px`);
			}
		}
		addEventListener('resize', throttle(fn), false);
		fn();
	}


	// ----

	const site = document.querySelector('.part-site-header-bg');
	const sh   = document.querySelector('.site-header');
	const eh   = document.querySelector('.part-top-visual');

	function setTopVisualBackground() {
		const b1 = sh.getBoundingClientRect();
		const b2 = eh.getBoundingClientRect();

		const h = b2.bottom - b1.top;
		site.style.setProperty('--header-bg-height', `${h}px`);
		site.classList.add('visible');
	}

	const header = document.querySelector('.site-header');
	const main   = header.querySelector('.main');
	const sub    = header.querySelector('.sub');

	let st = null;
	const onResize = () => {
		clearTimeout(st);
		st = setTimeout(() => {
			const hm = main.getBoundingClientRect().height;
			const hs = sub.getBoundingClientRect().height;
			document.documentElement.style.setProperty('--header-main-height', `${hm}px`);
			document.documentElement.style.setProperty('--header-sub-height', `${hs}px`);

			setElementSizeAndAlignment();
			setTimeout(setTopVisualBackground, 0);

			if (window.innerWidth < 900 && 600 < window.innerHeight && window.innerHeight < 900) {
				header.classList.add('full');
			} else {
				header.classList.remove('full');
			}
		}, 10);
	};
	window.addEventListener('resize', throttle(onResize), { passive: true });
	onResize();
});
